import { createActionGroup, props } from '@ngrx/store';
import { CategoryType, ErrorModel } from '@rocksoft/shared';
import { Category } from '../router/category';
import { VppApplicationConfiguration } from './category-vpp-applications.state';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const CategoryVppApplicationsResolverActions = createActionGroup({
  source: 'Category VPP Applications Resolver',
  events: {
    'Applications Requested': props<{ category: Category }>(),
  },
});

export const DeviceConfiguredApplicationsResolverActions = createActionGroup({
  source: 'Device Configured Application Resolver',
  events: {
    'VPP Applications Requested': props<{ categoryId: string; categoryType: CategoryType }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const CategoryVppApplicationsApiActions = createActionGroup({
  source: 'Category VPP Applications API',
  events: {
    'Applications Loaded': props<{
      applications: VppApplicationConfiguration[];
      categoryType: CategoryType;
      categoryId: string;
    }>(),
    'Applications Loaded Error': props<{ error: ErrorModel }>(),
    'Application Configurations Updated Error': props<{
      categoryId: string;
      categoryType: CategoryType;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryVppApplicationsViewActions = createActionGroup({
  source: 'Category VPP Application View',
  events: {
    'Application Configurations Updated': props<{
      categoryId: string;
      categoryType: CategoryType;
      previousApplicationsLinkedToCategory: VppApplicationConfiguration[];
      updatedApplicationsLinkedToCategory: VppApplicationConfiguration[];
    }>(),
  },
});

// ============================================================================
// EFFECT ACTIONS
// ============================================================================

export const CategoryVppApplicationsEffectActions = createActionGroup({
  source: 'Category VPP Applications Effect',
  events: {
    'Applications Requested': props<{ categoryId: string; categoryType: CategoryType }>(),
  },
});
